import BackToTop from "./modules/BackToTop";
import Clickable from "./modules/Clickable";
import SearchPopover from "./modules/SearchPopover";
import MainMenu from "./modules/MainMenu";
import MobileMenu from "./modules/MobileMenu";
import MobileMenuToggle from "./modules/MobileMenuToggle";
import BreakPoints from "./modules/BreakPoints";
import StickyHeader from "./modules/StickyHeader";
import SearchBar from "./modules/SearchBar";
import GalleryIsotope from "./modules/Gallery/Isotope";
import TinySlider from "./modules/Carousel/TinySlider";
import LayoutSections from "./modules/LayoutSections";
import GridMasonry from "./modules/Grid/GridIsotope";
import SlickCarousel from "./modules/Carousel/SlickCarousel";
import ContentSlider from "./modules/ContentSlider";
import ObjectFit from "./modules/ObjectFit";

jQuery(function(){
    ObjectFit.bind();
    BreakPoints.init();
    LayoutSections.bind();
    TinySlider.bind();
    SlickCarousel.bind();
    GalleryIsotope.bind();
    BackToTop.bind();
    Clickable.bind();
    SearchPopover.bind();
    SearchBar.bind();
    MainMenu.bind();
    MobileMenuToggle.init();
    MobileMenu.init();
    StickyHeader.bind();
    GridMasonry.bind();
    ContentSlider.bind();
});
